/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export function setGtmClass(className: string) {
  document
    ?.getElementsByClassName(className)[0]
    ?.getElementsByTagName('span')[0]
    ?.classList.add(className);
}
